import logo from '../../../src/assets/images/logo-rpc-full.png';

const LogoMainRpc = () => {
  return <img src={logo} width="100" height="80" alt="logo-rpc" />;
};

export default LogoMainRpc;
